import { useEffect } from 'react';

export function useWatch<E>(state: E, cb: (newData: E) => void): void {
  useEffect(() => {
    cb(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);
}
